import axios from 'axios'
import qs from 'qs'
import {Loading, Message} from 'element-ui'
import Router from '@/router/index'

const service = axios.create({
  // api的base_url
  baseURL: 'https://app.jianxuedu.com',
  // baseURL: 'https://ffjzapi.mmqo.com/',
  // 请求超时时
  timeout: 9007199254740992
})

/* request拦截器==>对请求参数做处理 */
service.interceptors.request.use(config => {
  if (!config.loding) {
    Loading.service({
      text: '加载中'
    })
  }

  if (config.method === 'post' && config.headers['Content-Type'] !== 'multipart/form-data') {
    config.data = qs.stringify({...config.data})
  } else {
    config.params = {...config.params}
  }
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  return config
  // 请求错误处理
}, error => {
  Promise.reject(error)
})

/* respone拦截器==>对响应做处理 */
service.interceptors.response.use(
  // 成功请求到数据
  response => {
    Loading.service({
      text: '加载中'
    }).close()
    /* 这里根据后端提供的数据进行对应的处理 */
    if (response.data.points_name !== '') {
      Message({
        message: '恭喜你完成' + response.data.points_name + '，获得' + response.data.points + '积分',
        type: 'info',
        duration: 3500
      })
    }
    if (response.data.code !== 0) {
      Message({
        message: response.data.msg,
        type: 'error',
        duration: 2000
      })
      if (response.data.code === 1001) {
        Router.replace({path: '/login'})
      }
    }
    return response.data
  },
  // 响应错误处理
  error => {
    Loading.service({
      text: '加载中'
    }).close()
    let text = JSON.parse(JSON.stringify(error)).response.status === 404
      ? '404'
      : '网络异常，请重试'
    Message({
      message: text,
      type: 'error',
      duration: 2000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/axios/axios.js